export enum TableFilterType {
  Integer,
  String,
  Date,
  Boolean,
  Guid
}
